import { getDeviceInfo } from '../hooks/useDeviceInfo';
import store from '../store';
import { addressSlice, appSlice, cardSlice } from '../store/slices';
import RequestService from './RequestService';

const StorageService = {
	Initialize: async () => {
		await StorageService.GetAmlSettings();
	},
	GetAmlSettings: async () => {
		const amlRiskSettings = await RequestService.GetAmlSettings();

		if (amlRiskSettings['Status'] !== 'Success') {
			return;
		}

		store.dispatch(addressSlice.actions.setAmlSettings(amlRiskSettings));
	},
	UpdateCurrencies: async () => {
		try {
			store.dispatch(appSlice.actions.setAvailableCurrenciesLoading(true));

			const responses = await Promise.allSettled([
				RequestService.GetCurrencies(),
				RequestService.GetAvailableCurrencies(),
			]);
			if (responses[0]?.value?.Status === 'Success')
				store.dispatch(appSlice.actions.setCurrencies(responses[0].value?.Currencies));
			if (responses[1]?.value?.Status === 'Success') {
				const currenciesList = responses[0].value?.Currencies || [];
				const availableCurrenciesList = responses[1].value?.Currencies || [];
				const availableCurrencies = availableCurrenciesList.map(({ CurrencyId, ...availableCurrency }) => {
					const curencyObj = currenciesList.find(currency => currency.Id === CurrencyId) || {};
					return { ...curencyObj, ...availableCurrency };
				});
				store.dispatch(appSlice.actions.setAvailableCurrencies(availableCurrencies));
			}
		} catch (error) {
			console.log(error);
		} finally {
			store.dispatch(appSlice.actions.setAvailableCurrenciesLoading(false));
		}
	},
	UpdateDevices: async () => {
		try {
			const response = await RequestService.GetAllDevice();
			if (response.Status === 'Success') store.dispatch(appSlice.actions.setDevices(response.Devices));
		} catch (error) {
			console.log(error);
		}
	},
	UpdateQuotes: async () => {
		try {
			const response = await RequestService.GetQuotes();

			if (!response) return;

			if (response.Status !== 'Success') {
				throw Error();
			} else {
				store.dispatch(appSlice.actions.setQuotes(response.Quotes));
			}
		} catch (error) {
			console.log(error);
		}
	},
	UpdateBillingBalance: async () => {
		try {
			const response = await RequestService.GetBillingBalance();

			if (!response) return;

			if (response.Status !== 'Success') {
				throw Error();
			} else {
				store.dispatch(appSlice.actions.setBillingBalance(response.Balance < 0 ? 0 : response.Balance));
			}
		} catch (error) {
			console.log(error);
		}
	},
	UpdateTariffList: async () => {
		try {
			const response = await RequestService.GetBillingTariffList();

			if (!response) return;

			if (response.Status !== 'Success') {
				throw Error();
			} else {
				const sortedTariffs = response.TariffPayments.sort((a, b) => b?.Amount - a?.Amount);
				const tariff = sortedTariffs.find(({ ServiceName }) => ServiceName === 'Energy');
				const maxTariff = sortedTariffs.find(({ ServiceName }) => ServiceName === 'LargeEnergy');
				store.dispatch(
					appSlice.actions.setTariffData({
						tariff: tariff?.Amount,
						maxTariff: maxTariff?.Amount,
					})
				);
			}
		} catch (error) {
			console.log(error);
		}
	},
	UpdateUserCurrentPermissions: async () => {
		try {
			const response = await RequestService.GetUserCurrentPermissions();

			if (!response) return;

			if (response.Status !== 'Success') {
				throw Error();
			} else {
				const currenciesPermissions = response.Rights?.find(right => right.Name === 'Currency')?.Value;
				const addressesPermissions = response.Rights?.find(right => right.Name === 'Address')?.Value;
				const paymentPurposePermissions = response.Rights?.find(right => right.Name === 'PaymentPurpose')?.Value;
				store.dispatch(
					appSlice.actions.setUserPermissions({
						currency: currenciesPermissions,
						address: addressesPermissions,
						paymentPurpose: paymentPurposePermissions,
					})
				);
			}
		} catch (error) {
			console.log(error);
		}
	},
	GetDeviceInfo: async () => {
		try {
			const deviceInfo = await getDeviceInfo();

			if (!deviceInfo) return;

			store.dispatch(appSlice.actions.setDeviceInfo(deviceInfo));
		} catch (e) {}
	},
	UpdateCardList: async () => {
		try {
			const response = await RequestService.GetCards();

			if (!response) return;

			if (response.Status !== 'Success') {
				store.dispatch(cardSlice.actions.setCardsList([]));
			} else {
				store.dispatch(cardSlice.actions.setCardsList(response.Cards));
			}
		} catch (error) {
			console.log(error);
		}
	},
};

export default StorageService;
